import { AbstractControl } from '@angular/forms';

export const allowOnlyXCharsAndMaxNumber = (
  control: AbstractControl,
  input: HTMLInputElement,
  maxChars: number,
  maxNumber: number
) => {
  const htmlInputValue = input.value;

  if (htmlInputValue.length > maxChars) {
    const value = +htmlInputValue.substring(1, htmlInputValue.length);
    control.setValue(value);
  }

  if (control.value > maxNumber) {
    control.setValue(maxNumber);
  }

  if (control.value === maxNumber) {
    // control.setValue(+htmlInputValue.substring(htmlInputValue.length - 1));
  }

  if (control.value < 10) {
    control.setValue('0' + control.value);
  }
};
